import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AnniversaryContainer.css";
import Navbar from "../Navbar.js";
import Header from "../HeaderAdmin.js";
import Submenu from "../Submenu.js";
import { SITE_ANNIVERSARY } from "../ApiDetails.js";

const AnniversaryContainer = () => {

  const [reportsData, setReportsData] = useState([]);
  const [topCountries, setTopCountries] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState({});
  const [reportsFilter, setReportsFilter] = useState({
    milestone: "All",
    startYear: 2024,
    endYear: 2031,
    // toggleValue: false,
    reRender: "no",
  });

  useEffect(() => {
    const initialFetch = async () => {
      try {
        const { startYear, endYear } = reportsFilter;
        const filterParams = new URLSearchParams();

        filterParams.append("startdate", startYear);
        filterParams.append("enddate", endYear);

        const apiUrl = `${SITE_ANNIVERSARY}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
        const response = await axios.get(apiUrl);

        setReportsData(response.data); 
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    initialFetch();
  }, [reportsFilter.reRender]);

  const handleApplyFilterClick = async () => {
    try {
      const { milestone, startYear, endYear } = reportsFilter;

      const filterParams = new URLSearchParams();

      if (milestone && milestone !== "All") {
        filterParams.append("milestone", milestone);
      }

      filterParams.append("startdate", startYear);
      filterParams.append("enddate", endYear);

      const apiUrl = `${SITE_ANNIVERSARY}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
      const response = await axios.get(apiUrl);

      setReportsData(response.data);
    } catch (error) {
      console.error("Error fetching filtered site event details:", error);
    }
  };

  const handleClearAllFilters = () => {
    setReportsFilter((prevState) => ({
      ...prevState, 
      milestone: "",
      startYear: 2024,
      endYear: 2031,
      reRender: prevState.reRender === "yes" ? "no" : "yes", // Toggle reRender value
    }));
    setReportsData([]);
    setFilteredEvents([]);
  };
  

  useEffect(() => {
    const groupedData = groupEventsByYear(reportsData);
    // setEventsData(groupedData);
    setFilteredEvents(groupedData);
    setTopCountries(groupEventsByCountry(reportsData));
  }, [reportsData]);

  const groupEventsByYear = (data) => {

    if(data.length === 0){
      return data;
    }
    const yearRange = getYearRange(reportsFilter);
    const eventsByYear = data.reduce((acc, event) => {
      const year = event.anniversary_Year;
      if (yearRange.includes(year)) {
        if (!acc[year]) {
          acc[year] = [];
        }
        acc[year].push(event);
      }
      return acc;
    }, {});

    // Ensure all years in the range are included, even if they have no events
    yearRange.forEach((year) => {
      if (!eventsByYear[year]) {
        eventsByYear[year] = [];
      }
    });

    return eventsByYear;
  };

  const getYearRange = ({ startYear, endYear }) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };

  const groupEventsByCountry = (data) => {
    const countryEventCounts = data.reduce((acc, event) => {
      const country = event.country || "null"; // Use 'null' if country is null
      if (!acc[country]) {
        acc[country] = 0;
      }
      acc[country]++;
      return acc;
    }, {});
  
    // Convert the countryEventCounts object to an array and first sort by count,
    // then alphabetically by country name if the counts are equal
    const topCountries = Object.entries(countryEventCounts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => {
        // if (b.count === a.count) {
          return a.name.localeCompare(b.name); // Sort alphabetically if counts are equal
        // }
        // return b.count - a.count; // Otherwise, sort by count
      });
  
    return topCountries;
  };
  

  return (
    <div>
      <Header />
      <div
      className="reportsContainerPadding"
      >
        
      
        <Navbar />
        <div className="single-card-container">
        <div className="cards submenuContainer">
            <Submenu reportsData={reportsData} />
          </div>
        </div>
        <div className="single-card-container filter">

        <div className="cards">
          <div className="row">
            <div className="d-flex bd-highlight" style={{alignItems: "baseline"}} >
              <div className="p-2 flex-fill bd-highlight">
                <h4 className="reportTitle mt-3">FILTERS</h4>
              </div>
              <div className="p-2 col-9 d-flex align-content-start flex-wrap">
                <div className="col">
                  <div className="row">
                    <div className="col">
                      <div className="input-group mb-0">
                        <label
                          className="input-group-text input-group-text-custom"
                          htmlFor="startYear"
                        >
                          START YEAR
                        </label>
                        <input
                          type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                          className="form-control-custom rounded form-input"
                          id="startYear"
                          value={reportsFilter.startYear}
                          onChange={(e) =>
                            setReportsFilter({
                              ...reportsFilter,
                              startYear: parseInt(e.target.value, 10),
                            })
                          }
                          placeholder="Start Year"
                          max="2100"
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="input-group mb-0">
                        <label
                          className="input-group-text input-group-text-custom"
                          htmlFor="endYear"
                        >
                          END YEAR
                        </label>
                        <input
                          type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                          className="form-control-custom rounded form-input"
                          id="endYear"
                          value={reportsFilter.endYear}
                          onChange={(e) =>
                            setReportsFilter({
                              ...reportsFilter,
                              endYear: parseInt(e.target.value, 10),
                            })
                          }
                          placeholder="End Year"
                          max="2100"
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="input-group mb-0">
                        <label
                          className="input-group-text input-group-text-custom"
                          htmlFor="milestone"
                        >
                          MILESTONE
                        </label>
                        <select
                          className="form-control-custom rounded form-select"
                          aria-label="Milestone"
                          id="milestone"
                          value={reportsFilter.milestone}
                          onChange={(e) => {
                            setReportsFilter({
                              ...reportsFilter,
                              milestone: e.target.value,
                            });
                          }}
                        >
                          <option value="all">All</option>
                          <option value="10">10 years</option>
                          <option value="15">15 years</option>
                          <option value="20">20 years</option>
                          <option value="25">25 years</option>
                          <option value="30">30 years</option>
                          <option value="35">35 years</option>
                          <option value="40">40 years</option>
                          <option value="45">45 years</option>
                          <option value="50">50 years</option>
                          <option value="55">55 years</option>
                          <option value="60">60 years</option>
                          <option value="65">65 years</option>
                          <option value="70">70 years</option>
                          <option value="75">75 years</option>
                          <option value="80">80 Years</option>
                          <option value="85">85 Years</option>
                          <option value="90">90 Years</option>
                          <option value="95">95 Years</option>
                          <option value="100">100 Years</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col text-end">
                  <button
                    className="btn-primary-custom p-1 mt-4"
                    onClick={handleApplyFilterClick}
                  >
                    Apply Filters
                  </button>
                  <button className="btn-secondary-custom" onClick={handleClearAllFilters}>
                    Clear All
                  </button>
                </div>
            </div>
          </div>
        </div>
        </div>

        {/* Statistics Section */}
        <div className="stats-and-events anniversary-data-container">
          <div className="stats-section col-md-4 cards">
            <div className="stats-column">
              <div className="stats-title">
                Total Per Year <span>FOR MILESTONE SELECTED</span>
              </div>
              {Object.keys(filteredEvents).map((year) => (
                <div className="stats-bar" key={year}>
                  <span>{year}</span>
                  <div className="bar-container">
                    <div
                      className="bar-fill"
                      style={{
                        width: `${
                          (filteredEvents[year].length /
                            Math.max(
                              ...Object.values(filteredEvents).map(
                                (y) => y.length
                              )
                            )) *
                          100
                        }%`,
                      }}
                    >
                      &nbsp;
                    </div>
                  </div>
                  <span className="bar-count">
                    {filteredEvents[year].length}
                  </span>
                </div>
              ))}
            </div>
            <div
              style={{ border: "1px solid #dadde5", margin: "5px 5px" }}
            ></div>
            <div className="stats-column">
              <div className="stats-title">
                Top Countries <span>FOR DATE RANGE SELECTED</span>
              </div>
              {topCountries.map((country) => (
                <div className="stats-bar" key={country.name}>
                  <span>{country.name === "null" ? "null" : country.name}</span>
                  <div className="bar-container">
                    <div
                      className="bar-fill"
                      style={{width: `${(country.count / topCountries[0].count) * 100}%`,}} // Adjust width relative to max count
                    >
                      &nbsp;
                    </div>
                  </div>
                  <span className="bar-count">{country.count}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Yearly Events Section */}
          <div className="years-section col-md-8"> 
          {Object.keys(filteredEvents).map((year) => (
            <div className="year-column" key={year}>
              <div className="year-title">
                <p>{year}</p>
                <span>TOTAL: {filteredEvents[year].length}</span>
              </div>
              {filteredEvents[year].map((event) => (
                <div
                  className="event-item"
                  key={
                    event.site_code +
                    event.move_in_date +
                    event.next_Anniversary_date
                  }
                  style={{
                    backgroundColor: event.eventInAnniversaryYear === "Yes" ? "lightgreen" : ""
                  }}
                >
                  <div>
                    <p>
                      {event.site_code}
                      <span>
                        {" "}{event.upcoming_Anniversary}
                      </span>
                    </p>
                    <span>
                      {new Date(event.move_in_date).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default AnniversaryContainer;
